import { routePaths } from 'appConfig';
import { ReactNode } from 'react';

interface MenuItem {
  to: string;
  label: ReactNode;
}

export const aboutUsItems: MenuItem[] = [
  {
    to: routePaths.OUR_STORY,
    label: 'Our Story',
  },
  {
    to: routePaths.THE_YB_EFFECT,
    label: 'The YB Effect',
  },
  {
    to: routePaths.CAUSES_WE_SUPPORTED,
    label: 'Causes We’ve Supported',
  },
  {
    to: routePaths.CATERING,
    label: 'Catering',
  },
  {
    to: routePaths.YB_EXPRESS,
    label: 'YB Express',
  },
  {
    to: routePaths.CONTACT_US,
    label: 'Contact Us',
  },
];

export const howItWorksItems: MenuItem[] = [
  {
    to: routePaths.HOW_TO_ORDER,
    label: 'How to Order',
  },
  {
    to: routePaths.DOORSTEP_DELIVERY,
    label: 'Doorstep Delivery',
  },
  {
    to: routePaths.CLICK_AND_COLLECT,
    label: 'Click & Collect',
  },
];

export const guidesItems: MenuItem[] = [
  {
    to: routePaths.MEALCARE,
    label: 'Meal Care Instructions',
  },
  {
    to: routePaths.IS_YUMMY_BROS_HALAL,
    label: 'Is Yummy Bros Halal?',
  },
  {
    to: routePaths.WEIGHT_LOSS_TIPS,
    label: 'Weight Loss Tips',
  },
  {
    to: routePaths.WEEKLY_MEAL_PLANNER,
    label: 'Meal Planner',
  },
  {
    to: routePaths.MY_FITNESS_PAL,
    label: 'My Fitness Pal',
  },
  {
    to: routePaths.FAQS,
    label: 'FAQ',
  },
];

export const mealPreps: MenuItem[] = [
  {
    to: routePaths.HOW_TO_ORDER,
    label: 'How to Order',
  },
  {
    to: routePaths.DOORSTEP_DELIVERY,
    label: 'Doorstep Delivery',
  },
  {
    to: routePaths.CLICK_AND_COLLECT,
    label: 'Click and Collect',
  },
  {
    to: routePaths.MEALCARE,
    label: 'Meal Care Instructions',
  },
  {
    to: routePaths.WEIGHT_LOSS_TIPS,
    label: 'Weight Loss Tips',
  },
  {
    to: routePaths.IS_YUMMY_BROS_HALAL,
    label: 'Is Yummy Bros Halal?',
  },
  {
    to: routePaths.YB_REPS,
    label: 'Loyalty Programme',
  },
  {
    to: routePaths.MY_FITNESS_PAL,
    label: 'My Fitness Pal',
  },
  {
    to: routePaths.WEEKLY_MEAL_PLANNER,
    label: 'Weekly Meal Planner',
  },
  {
    to: routePaths.GIFT_CARDS,
    label: 'Buy Gift Cards',
  },
];
